import { dataApiUrl } from 'utils/url';
import AuthAxios from 'utils/authAxios';

const DataApiUrl = dataApiUrl();

const Groups = () => {
  const getAllSegmented = async () => {
    const rowsPerPage = 100;

    const { total, results } = await getNextSegmentOfGroups({ params: { rowsPerPage, page: 0 } });
    const pages = [...Array(Math.floor(total / rowsPerPage))];
    let data = results;

    const totals = await Promise.all(
      pages.map(async (_, i) => {
        const { results } = await getNextSegmentOfGroups({ params: { rowsPerPage, page: i + 1 } });
        return results;
      })
    );
    return data.concat(totals.flat());
  };

  const getNextSegmentOfGroups = params =>
    AuthAxios.get(`${DataApiUrl}/admin/groups`, params)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getAllWithRecoup = params =>
    AuthAxios.get(`${DataApiUrl}/admin/groups/withRecoupAccounts`, { params })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getWithRecoup = id =>
    AuthAxios.get(`${DataApiUrl}/admin/groups/${id}/withRecoupAccounts`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const getAllWithSubscription = params =>
    AuthAxios.get(`${DataApiUrl}/admin/groups/withSubscriptions`, { params })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const create = (name, email, is_label_account) =>
    AuthAxios.post(`${DataApiUrl}/admin/groups`, { name, email, is_label_account })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const patch = (id, data) =>
    AuthAxios.patch(`${DataApiUrl}/admin/groups/${id}`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const createPayeeIndividual = (id, email, name) =>
    AuthAxios.post(`${DataApiUrl}/admin/groups/${id}/payees/user`, {
      email,
      name,
    })
      .then(res => res.data)
      .catch(err => {
        throw err.response;
      });

  const getPayees = id =>
    AuthAxios.get(`${DataApiUrl}/admin/groups/${id}/payees`)
      .then(res => res.data.data.results)
      .catch(err => {
        throw err.response;
      });

  const getUsers = id =>
    AuthAxios.get(`${DataApiUrl}/groups/${id}/users`)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const updateUserRole = (id, userId, data) =>
    AuthAxios.patch(`${DataApiUrl}/admin/groups/${id}/users/${userId}`, data)
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const inviteUser = (id, email, role) =>
    AuthAxios.post(`${DataApiUrl}/groups/${id}/invite`, {
      email,
      role,
    })
      .then(res => res.data.data)
      .catch(err => {
        throw err.response;
      });

  const setGroupRestriction = (groupId, restriction) =>
    AuthAxios.post(`${DataApiUrl}/admin/groups/${groupId}/restriction`, { restriction }).catch(err => {
      throw err.response;
    });

  return {
    getAllSegmented,
    getAllWithRecoup,
    getAllWithSubscription,
    create,
    patch,
    createPayeeIndividual,
    getPayees,
    getWithRecoup,
    getUsers,
    inviteUser,
    updateUserRole,
    setGroupRestriction,
  };
};

export default Groups;
